import React, { useState } from 'react';
import { IconButton, FocusTrapCallout } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { Color } from '../../const/Const';
import ButtonSecondary from '../ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../ButtonDefault/ButtonDefault';

const ButtonDelete = (props) => {

    const buttonId = useId();
    const [show, setShow] = useState(false);


    const yes = () => {
        setShow(false);
        props.onClick();
    }

    const no = () => {
        setShow(r => !r);
    }

    const onPress = () => {
        setShow(r => !r);
    }

    return (
        <div>
            <IconButton id={buttonId} iconProps={{ iconName: 'Delete' }} title={props.text} style={{ color: Color.black }} onClick={onPress} />
            {show ? (
                <FocusTrapCallout
                    role="alertdialog"
                    gapSpace={0}
                    target={`#${buttonId}`}>
                    <div style={{ padding: 16 }}>
                        <div>Та устгахдаа итгэлтэй байна уу?</div>
                        <div style={{ display: 'flex', marginTop: 16 }}>
                            <ButtonSecondary text="Үгүй" onClick={no} />
                            <div style={{ marginLeft: 16 }}>
                                <ButtonDefault text="Тийм" onClick={yes} />
                            </div>
                        </div>
                    </div>
                </FocusTrapCallout>
            ) : null}
        </div>
    );
}

export default ButtonDelete;